export enum StatusCodes {
    InternetError = 0,
    Success = 200,
    Accepted = 202,
    NoContent= 204,
    NotFound = 404,
    BadRequest = 400,
    ForbiddenAccess= 403,
    Conflict = 409,
    InternalServerError = 500,
  }